var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"v-placeholder"},[_c('v-text',{staticClass:"text-center",attrs:{"font-size":"5"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }